import {Button} from '@/components/ui/button/Button'
import {CheckCircleIcon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n'
import {
    StyledBulkSiarExportDialogFooter,
    StyledBulkSiarExportResultBody,
    StyledBulkSiarExportResultFileName,
    StyledBulkSiarExportResultIcon,
    StyledBulkSiarExportResultSubtitle,
    StyledBulkSiarExportResultTitle
} from '@/features/projects/siar-bulk-export/components/bulk-siar-export-dialog/style'

type BulkSiarExportResultStepProps = {
    pendingCount: number
    fileName: string
    onClose: () => void
    onGoToGroup?: () => void
}

export const BulkSiarExportResultStep = ({
    pendingCount,
    fileName,
    onClose,
    onGoToGroup
}: BulkSiarExportResultStepProps) => {
    const {t} = useTranslation()

    return (
        <>
            <StyledBulkSiarExportResultBody>
                <StyledBulkSiarExportResultIcon>
                    <CheckCircleIcon size={48} />
                </StyledBulkSiarExportResultIcon>
                <StyledBulkSiarExportResultTitle>
                    {t('projects:bulk_siar_export_success_title')}
                </StyledBulkSiarExportResultTitle>
                <StyledBulkSiarExportResultFileName>{fileName}</StyledBulkSiarExportResultFileName>
                <StyledBulkSiarExportResultSubtitle>
                    {t('projects:bulk_siar_export_success_subtitle', {count: pendingCount})}
                </StyledBulkSiarExportResultSubtitle>
            </StyledBulkSiarExportResultBody>
            <StyledBulkSiarExportDialogFooter>
                {onGoToGroup && (
                    <Button variant="secondary" onClick={onGoToGroup}>
                        {t('projects:bulk_siar_export_go_to_group')}
                    </Button>
                )}
                <Button variant="primaryNeutral" onClick={onClose}>
                    {t('commons:close')}
                </Button>
            </StyledBulkSiarExportDialogFooter>
        </>
    )
}
